import React from 'react';
import Markdown from 'markdown-to-jsx';
import { styled } from '@mui/material/styles';

const StyledLink = styled('a')({
  wordBreak: 'break-word',
});

const CustomLink = (props: React.ComponentPropsWithoutRef<'a'>) => {
  return <StyledLink {...props} />;
};

const MarkdownToJsx = (props: React.ComponentProps<typeof Markdown>) => (
  <Markdown
    {...props}
    options={{
      ...props.options,
      overrides: {
        a: {
          component: CustomLink,
        },
      },
    }}
  />
);

export default MarkdownToJsx;
